import { kanboardConstants } from "../../_constants";

const initialState = {};

//job details reducer
export const get_kanboard_job_details_hiring_manager_reducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case kanboardConstants.GET_KANBOARD_JOBS_HIRING_MANAGER_ACTION_REQUEST:
      return {
        type: "alert-success",
        message: action.payload,
      };
    case kanboardConstants.GET_KANBOARD_JOBS_HIRING_MANAGER_ACTION_SUCCESS:
      return {
        type: "alert-success",
        data: action.payload,
      };
    case kanboardConstants.GET_KANBOARD_JOBS_HIRING_MANAGER_ACTION_FAILURE:
      return {
        type: "alert-failure",
        message: action.payload,
      };
    default:
      return state;
  }
};

//job details reducer
export const get_kanboard_filtered_job_details_hiring_manager_reducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case kanboardConstants.GET_KANBOARD_FILTERED_JOBS_HIRING_MANAGER_ACTION_REQUEST:
      return {
        type: "alert-success",
        message: action.payload,
      };
    case kanboardConstants.GET_KANBOARD_FILTERED_JOBS_HIRING_MANAGER_ACTION_SUCCESS:
      return {
        type: "alert-success",
        filteredList: action.payload,
        status: action.status,
      };
    case kanboardConstants.GET_KANBOARD_FILTERED_JOBS_HIRING_MANAGER_ACTION_FAILURE:
      return {
        type: "alert-failure",
        message: action.payload,
      };
    default:
      return state;
  }
};
